var React = require('react');

function StarFill (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.76 8.20762L22 8.43262L15.465 13.4765L17.7986 21.4117L11.0002 16.7326L4.20187 21.4117L6.53531 13.4758L0 8.43263L8.2403 8.20762L11.0002 0.411743L13.76 8.20762Z","fill":"#74CA3F"}));
}

StarFill.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = StarFill;

StarFill.default = StarFill;
